export enum Currency {
  USD = 'USD',
}

export default interface Money {
  currency: Currency;
  amount: number;
}
